












import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { HubLoading } from '@/components/HubComponents';

export default Vue.extend({
  name: 'ViewCallbackYoutube',

  components: { HubLoading },

  computed: {
    ...mapState(['events', 'liveSocial', 'user']),
    description(): string {
      return this.liveSocial.general.description;
    },
    eventState(): Store.Events.Event {
      return this.events.event;
    },
    madeForKids(): boolean {
      return this.liveSocial.general.madeForKids;
    },
    privacyStatus(): Store.LiveSocial.Youtube.PrivacyStatus {
      return this.liveSocial.general.privacyStatus;
    },
    title(): string {
      return this.liveSocial.general.title;
    },
    userState(): Store.User.State {
      return this.user;
    },
    liveSocialState(): Store.LiveSocial.State {
      return this.liveSocial;
    },
  },

  mounted() {
    // Transforma o "query parameter" em um objeto
    const search = window.location.search.substring(1);
    const queryParameterObject = JSON.parse(
      `{"${
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')
      }"}`,
    ) as { code: string; state: string };

    const redirectUrl = atob(decodeURIComponent(queryParameterObject.state));
    const hash = redirectUrl.split('/')[4];

    this.getUserData({
      code: decodeURIComponent(queryParameterObject.code),
      redirect_url: `${window.location.origin}/callback/youtube`,
    })
      .then(async (userData) => {
        console.log('User data: ', userData);
        if (userData.user_id) {
          await this.loadEvent({
            planId: parseInt(this.userState.planId, 10),
            hash,
          } as Services.Events.GetEvent);

          let userAccount = await this.loadUserAccountByUserId({
            customerPlansEventsId: this.eventState.id,
            customerPlansId: this.userState.planId,
            userId: userData.user_id,
          });

          console.log('User account: ', userAccount);

          if (Object.keys(userAccount).length === 0) {
            console.log('Creating user account', {
              customer_plans_events_id: this.eventState.id,
              customer_plans_id: parseInt(this.userState.planId, 10),
              email: userData.email,
              name: userData.email.split('@')[0],
              provider: 'youtube',
              token: userData.access_token,
              user_data: JSON.stringify(userData),
              user_id: userData.user_id,
            });
            userAccount = await this.createUserAccount({
              customer_plans_events_id: this.eventState.id,
              customer_plans_id: parseInt(this.userState.planId, 10),
              email: userData.email,
              name: userData.email.split('@')[0],
              provider: 'youtube',
              token: userData.access_token,
              user_data: JSON.stringify(userData),
              user_id: userData.user_id,
            });
          }

          console.log('User account again: ', userAccount);

          await this.loadLiveSocialGeneral({
            customer_plans_events_id: this.eventState.id,
            customer_plans_id: this.userState.planId,
          } as Services.LiveSocial.GetLiveSocialGeneral);

          await this.createService(userAccount);

          this.redirectsToViewLiveSocial(hash);
        } else throw new Error('requestYoutubeToken error');
      })
      .catch((error: Error) => {
        switch (error.message) {
          case 'error_already_handled': break;
          case 'requestYoutubeToken error':
            console.error(error.message);

            this.showNotification({
              text: 'youtube_account_error',
              type: 'error',
            });
            break;
          default:
            console.error('[DEBUG VIEWCALLBACKYOUTUBE]', error);

            this.showNotification({
              text: 'general_error_service_operation',
              type: 'error',
            });
            break;
        }

        this.redirectsToViewLiveSocial(hash);
      });
  },

  methods: {
    ...mapActions({
      saveYoutubeLivestreamUserSettings: 'liveSocial/saveYoutubeLivestreamUserSettings',
      createServiceInDatabase: 'liveSocial/createService',
      loadEvent: 'events/loadEvent',
      loadLiveSocialGeneral: 'liveSocial/loadLiveSocialGeneral',
      createWowzaTarget: 'liveSocial/youtubeCreateStreamTarget',
      showNotification: 'notification/create',
      bindBroadcastToStream: 'liveSocial/youtubeBindBroadcastToStream',
    }),
    setTargetName(data: Services.LiveSocial.Youtube.SetTargetName): string {
      const {
        customerPlanName,
        provider,
        streamType,
        transmissionId,
      } = data;

      const providers = {
        custom: 'OT', // OT = others
        facebook: 'FB',
        instagram: 'IT',
        twitch: 'TC',
        twitter: 'TW',
        youtube: 'YT',
      };

      return `${providers[provider]}-${streamType}-${customerPlanName}-${transmissionId}`;
    },
    getTargetSettings(streamingUrl: string): Services.LiveSocial.Youtube.TargetSettings | null {
      const regex = /^(rtmps|rtmp)?(:\/\/)?([a-z]*-*[a-z-a-z.a-z*.a-z]*)?(:)?([0-9]*)?(\/)?([a-z0-9]*)/i;

      const config = regex.exec(streamingUrl);

      return config
        ? {
          destinationApplication: config[7],
          destinationHost: config[3],
          destinationPort: config[5] || '1935',
          destinationUseSsl: config[5] && config[5] === '443' ? 'true' : 'false',
        }
        : null;
    },
    async createYoutubeLiveBroadcast(
      payload: Services.LiveSocial.Youtube.PostLiveBroadcast,
    ): Promise<Services.LiveSocial.Youtube.Response.PostLiveBroadcastResponse> {
      return this.$store.dispatch('liveSocial/youtubeCreateLiveBroadcast', payload);
    },
    async createYoutubeLiveStream(
      payload: Services.LiveSocial.Youtube.PostLiveStream,
    ): Promise<Services.LiveSocial.Youtube.Response.PostLiveStreamResponse> {
      return this.$store.dispatch('liveSocial/youtubeCreateLiveStream', payload);
    },
    async createYoutubeLiveSocial(
      service: Store.LiveSocial.LiveSocialNetwork,
      userId: string,
    ): Promise<Store.LiveSocial.LiveSocialNetwork> {
      const scheduledStartTime = new Date();
      const scheduledEndTime = new Date(
        new Date().setHours(scheduledStartTime.getHours() + 1),
      );

      const {
        description, title,
      } = this.liveSocialState.general;

      console.log('Creating youtube broadcast', {
        title,
        description,
        part: ['contentDetails', 'id', 'snippet', 'status'],
        scheduledEndTime,
        scheduledStartTime,
        selfDeclaredMadeForKids: this.madeForKids,
        status: this.privacyStatus,
        user_id: userId,
      });
      const liveBroadcast = await this.createYoutubeLiveBroadcast({
        title,
        description,
        part: ['contentDetails', 'id', 'snippet', 'status'],
        scheduledEndTime,
        scheduledStartTime,
        selfDeclaredMadeForKids: this.madeForKids,
        status: this.privacyStatus,
        user_id: userId,
      });

      console.log('Creating youtube stream', {
        frameRate: '30fps',
        ingestionType: 'rtmp',
        part: ['cdn', 'id', 'snippet', 'status'],
        resolution: '1080p',
        title,
        user_id: userId,
      });
      const liveStream = await this.createYoutubeLiveStream({
        frameRate: '30fps',
        ingestionType: 'rtmp',
        part: ['cdn', 'id', 'snippet', 'status'],
        resolution: '1080p',
        title,
        user_id: userId,
      });

      console.log('Binding broadcast to stream', {
        id: liveBroadcast.id,
        part: ['contentDetails', 'id', 'snippet', 'status'],
        streamId: liveStream.id,
        user_id: userId,
      });
      await this.bindBroadcastToStream({
        id: liveBroadcast.id,
        part: ['contentDetails', 'id', 'snippet', 'status'],
        streamId: liveStream.id,
        user_id: userId,
      } as Services.LiveSocial.Youtube.PostBindBroadcastToStream);

      const providerSettings = {
        streaming_id: liveBroadcast.id,
        streaming_key: liveStream.cdn.ingestionInfo?.streamName,
        streaming_secure_url: '',
        streaming_url: liveStream.cdn.ingestionInfo?.ingestionAddress,
      } as Store.LiveSocial.ProviderSettings;

      const newService = {
        ...service,
        provider_settings: providerSettings,
        transmission_id: liveBroadcast.id,
      };

      console.log('Youtube service created: ', newService);
      return newService;
    },
    async updateService(
      service: Store.LiveSocial.LiveSocialNetwork,
    ): Promise<void> {
      const payload = {
        ...service,
        process_id: parseInt(service.id, 10),
        process_name: this.setTargetName({
          customerPlanName: `EVT-${this.eventState?.customer_plans_id}`,
          provider: service.provider,
          streamType: service.stream_type,
          transmissionId: service.transmission_id,
        }),
        status: 0,
      };
      console.log('Updating yt service: ', payload);
      await this.$store.dispatch('liveSocial/updateService', payload);
    },
    async createService(userAccount: Store.LiveSocial.UserSocialNetwork): Promise<void> {
      const scheduledStartTime = new Date();
      const scheduledEndTime = new Date(
        new Date().setHours(scheduledStartTime.getHours() + 1),
      );

      const dbservice = await this.createServiceInDatabase({
        description: this.description,
        email: userAccount.email,
        id_customer_plans: parseInt(this.userState.planId, 10),
        id_customer_plans_events: this.eventState.id,
        made_for_kids: this.madeForKids,
        name: userAccount.name,
        provider: 'youtube',
        provider_settings: '{}',
        scheduledEndTime,
        scheduledStartTime,
        social_id: userAccount.id.toString(),
        status_code: this.privacyStatus,
        stream_type: 'NOW',
        title: this.title,
        transmission_id: '',
        transmission_type: 'now',
      } as Services.LiveSocial.PostService);

      console.log('Db Service created: ', dbservice);

      // const service = await this.createYoutubeLiveSocial(dbservice, userAccount.user_id);
      // const targetSettings = this.getTargetSettings(service.provider_settings.streaming_url);

      // if (targetSettings) {
      //   const targetData = {
      //     application: `LVW-${this.eventState.customer_plans_lvw_id}`,
      //     sourceStreamName: this.eventState.stream,
      //     entryName: this.setTargetName({
      //       customerPlanName: `EVT-${this.eventState.customer_plans_id}`,
      //       provider: 'youtube',
      //       streamType: 'NOW',
      //       transmissionId: service.transmission_id,
      //     }),
      //     destination_host: targetSettings.destinationHost,
      //     destination_application: targetSettings.destinationApplication,
      //     destination_port: targetSettings.destinationPort,
      //     destination_stream_name: service.provider_settings.streaming_key,
      //     destination_use_ssl: targetSettings.destinationUseSsl,
      //   };
      //   console.log('Trying to create a target for youtube', targetData);
      //   await this.createWowzaTarget(targetData);

      //   await this.updateService(service);
      // }
      // console.log('Created youtube service: ', service);
    },
    createUserAccount(
      payload: Services.LiveSocial.PostUserAccount,
    ): Promise<Store.LiveSocial.UserSocialNetwork> {
      return this.$store.dispatch('liveSocial/createUserAccount', payload);
    },
    getUserData(
      payload: Services.LiveSocial.Youtube.GetUserData,
    ): Promise<Services.LiveSocial.Youtube.Response.GetUserData> {
      return this.$store.dispatch('liveSocial/youtubeGetUserData', payload);
    },
    loadUserAccountByUserId(
      payload: Services.LiveSocial.GetUserAccountByUserId,
    ): Promise<Store.LiveSocial.UserSocialNetwork> {
      return this.$store.dispatch('liveSocial/loadUserAccountByUserId', payload);
    },
    redirectsToViewLiveSocial(hash: string): void {
      this.$router.push({ name: 'LiveSocial', params: { hash } });
    },
  },
});
